module.exports = __webpack_public_path__ + "img/LS-J-13.48bdc108.svg";